import { Select } from "antd";
import { useEffect, useState } from "react";
import { RosterStatuses } from "~enums/rosterStatuses";

type Props = {
  isEditMode: boolean;
  defaultValue: string;
  onSave: (value: RosterStatuses) => Promise<void>;
  disabled: boolean;
};

const options = Object.values(RosterStatuses).map((item) => ({
  value: item,
  label: item,
}));

const RosterStatusEditableColumn = ({ isEditMode, defaultValue, onSave, disabled }: Props) => {
  const [value, setValue] = useState<any | null>(defaultValue);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const handleSave = async (value: RosterStatuses) => {
    setValue(value);
    setLoading(true);
    try {
      await onSave(value);
    } finally {
      setLoading(false);
    }
  };

  if (isEditMode) {
    return <Select disabled={loading || disabled} style={{ width: "100%" }} options={options} value={value} onSelect={handleSave} />;
  }

  return defaultValue;
};

export default RosterStatusEditableColumn;
